//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Button, ButtonStyle } from '@cmp/common';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { withTranslation } from 'react-i18next';

//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class OurBrands extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { className, t } = this.props;
    const componentClasses = classNames(styles.OurBrands, {
      [className]: className,
    });
    const BUTTONS = [
      {
        textI18nKey: 'landing_Healthy',
        url: t('url_healthy_advantage'),
      },
      {
        textI18nKey: 'landing_Prescription',
        url: t('url_prescription_diet'),
      },
      {
        textI18nKey: 'landing_Science',
        url: t('url_science_diet'),
      },
    ];
    const available_urls = BUTTONS.filter((buttonsURL) => buttonsURL.url != '');

    return (
      <div className={componentClasses}>
        <h1 className={styles.Title}>{t('landing_OurBrands')}</h1>
        {available_urls.map((button) => (
          <div key={button.url}>
            <a
              href={button.url}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.Btn}
            >
              {t(button.textI18nKey)}
            </a>
          </div>
        ))}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(OurBrands);
